<svg width="59" height="64" viewBox="0 0 59 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="22.2031" width="14.3673" height="63.9998" rx="2" fill="#B5D1FF" />
  <rect x="44.4102" y="37.8779" width="14.3673" height="26.1223" rx="2" fill="#002987" />
  <path
    d="M22.2031 15.6738H36.5704V62.0002C36.5704 63.1047 35.675 64.0002 34.5704 64.0002H24.2031C23.0986 64.0002 22.2031 63.1047 22.2031 62.0002V15.6738Z"
    fill="#0A66FF"
  />
  <rect y="24.8164" width="14.3673" height="39.1835" rx="2" fill="#002987" />
</svg>
